
<template>
  <logisticdetails-component>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card> 
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >  
                  <b-form-group label="Shipment Id" :label-cols="3"> 
                   <b-form-input class="input" type="text" name="shipmentid" v-model="customer.shipmentid" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.shipmentid') }" placeholder="Enter Shipment Id ">
                   </b-form-input>
                    <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                   </b-form-group>          
                </b-col> 
                <b-col md="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clear"> Clear</b-button>               
                </b-col>
              </b-row>  
            </form>
          </div>   
          

             <b-table show-empty  hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="logisticlogdata" :bordered="bordered" :fields="statusdata" caption-top>
              <!-- <template slot="table-caption"><b>Status For Logistics</b></template> -->
              <template slot="pushflag" slot-scope="row">

                <span>{{ (row.item.pushflag==0)?'-':(row.item.pushflag==1)?'Success':'Fail'}} </span> 
                
                </template>
            </b-table>
           
        </b-card>
      </b-col>
    </b-row>      
  </div>
</logisticdetails-component>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function () {
    return {
      isBusy: false,
      customer: {},
      outlined:true,
      bordered: true,
      data: [],
      items: [],
      dlvstatus:[],
      img1:[],
      imgpath:[],
      urlImg: [],
       customlogdata: [],
       logisticlogdata: [],
      // fields: [{key: 'shippingidsign', label: 'shippingid'}, {key: 'picklocation',label:'pickuplocationname'}, 'servicetype','shipmentstatus','deliverystatus','agentname','vendor_name','mobilenumber','shipaddress1','createddate'],
       statusdata:['shippingid','courierstatus','createddate',{key:'pushflag' , label:'Status' },{key:'return_response' , label:'Response' }],
      
      ConsignmentMasterGetdata: [],
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,

    }
  },
  created: function () {},
  methods: {
    validateForm(scope) {
      var searchvaluesarr = []
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
         
          var shipmentid = this.customer.shipmentid
          var searchvalues = shipmentid.split(',')
          for (var i = 0; i < searchvalues.length; i++) {
            searchvaluesarr.push(`${searchvalues[i]}`)
          }
          const customerGetAllobj = {
            shippingid: searchvaluesarr
          }


          // this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/consignmentactivitytrackinggetweb`, customerGetAllobj)
          //   .then((result) => {
          //     if (result.body.returnmsg && result.body.returnmsg === 'UnSuccessful') {
          //       this.data = []
          //       //alert('Result not found')
          //       this.isConsignmentActivityTrackingGetWeb = 1
          //       // var searchlisting = document.getElementById('searchlisting')
          //       // searchlisting.style.display = 'block'
          //     } else if (result.body.length === 0) {
          //       //alert('Result not found')
          //       this.data = []
          //       this.isConsignmentActivityTrackingGetWeb = 1
          //       // var searchlisting = document.getElementById('searchlisting')
          //       // searchlisting.style.display = 'block'
          //     } else {
          //       this.data = result.body
          //       this.isConsignmentActivityTrackingGetWeb = 1
          //       // var searchlisting = document.getElementById('searchlisting')
          //       // searchlisting.style.display = 'block'
          //     }
          //   })
          //   .catch((ex) => {
          //     console.log('error', ex)
          //   })


          // Added By Sachin On 06/02/2020  
          var shipmentidget1 = this.customer.shipmentid
          const customerstatusobj = {
          shippingid: `${shipmentidget1}`
          }
          this.isBusy = true;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getlogisticlogdetails`, customerstatusobj).then((result) => {
              if (result.body.returnvalue.length > 0) {
                
                this.logisticlogdata = result.body.returnvalue
                //conole.log("this.logisticlogdata",this.logisticlogdata);
                this.isGetlogisticlogdetails = 1
                this.isBusy =false
                
              } else {
                //alert('Result not found')
                this.logisticlogdata = []
                this.isGetlogisticlogdetails = 1
                this.isBusy = false

                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
          // Added By Sachin On 06/02/2020

            // Added By Sachin On 10/04/2020  
          // var shippingid = this.customer.shipmentid
          // const customobj = {
          // shippingid: `${shippingid}`
          // }
          // this.isBusy = true;
          // this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/statusforcustom`, customobj).then((result) => {
          //     if (result.body.returnvalue.length > 0) {
                
          //       this.customlogdata = result.body.returnvalue
          //       //conole.log("this.customlogdata",this.customlogdata);
          //       this.isGetlogisticlogdetails = 1
          //       this.isBusy = false
                
          //     } else {
          //       //alert('Result not found')
          //       this.customlogdata = []
          //       this.isGetlogisticlogdetails = 1
          //       this.isBusy = false;
                
          //     }
          //   })
          //   .catch((ex) => {
          //     console.log('error', ex)
          //   })
          // // Added By Sachin On 06/02/2020    




         //  var shipmentidget = this.customer.shipmentid
         //  const Getobj = {
         //    shippingid: `${shipmentidget}`
         //  }
         // // this.isBusy = true;
         //  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/consignmentmasterget`, Getobj)
         //    .then((result) => {
             
         //      if (result.body.length > 0) {
                 
         //        this.ConsignmentMasterGetdata = result.body
         //        this.img1 = result.body[0].vendorsign
         //        this.dlvstatus = result.body[0].shipmentstatus
                
         //        this.urlImg = result.body[0].shipment_images
         //        this.imgpath= JSON.parse(this.urlImg);
                
         //        this.isConsignmentMasterGetStatus = 1

         //        this.isBusy = false;
         //        // var searchlisting = document.getElementById('searchlisting2')
         //        // searchlisting.style.display = 'block'
         //      } else {
         //        //alert('Result not found')
         //        this.ConsignmentMasterGetdata = []
         //        this.isConsignmentMasterGetStatus = 1
         //        this.isBusy = false;
         //        // var searchlisting = document.getElementById('searchlisting2')
         //        // searchlisting.style.display = 'block'
         //      }
         //    })
         //    .catch((ex) => {
         //      console.log('error', ex)
         //    })
        }
      })
    },
    clear: function() {
      this.customer = {}
      this.errors.clear('form-1')
      var searchlisting = document.getElementById('searchlisting')
      searchlisting.style.display = 'none'
      var searchlisting2 = document.getElementById('searchlisting2')
      searchlisting2.style.display = 'none'
    }
  },

  filters: {
    datechange: function (value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
}
</script>
<style type="text/css">
  .b-table-caption-top{
    color: black;
  }

</style>
